<template>
  <div>
    <Hero heading="About" bg="bg_hiking.jpg" />
    <transition name="fade" appear>
      <div class="container">
        <h2>About Me</h2>
        <p>
          My name is
          <strong>Liang Wei</strong>, and I'm a Full-Stack Developer with nearly 10 years of experience in full-stack development and a strong background in real-world apps. I've spent the last 6 years as a professional web developer where I specialize in transforming beautiful designs into full-fledged interactive web applications for various clients all around the world.
        </p>
        <p>
          My job involves doing what I love,
          <strong>developing</strong> new websites and applications. I absolutely love learning new things and taking on new challenges. A more detailed look at my professional capabilities and experience is available in my
          <a
            href="/liang-wei-resume.pdf"
            target="_blank"
          >resume</a>.
        </p>
        <div class="h-text-center">
          <blockquote>
            <span>"Success consists of going from failure to failure without loss of enthusiasm."</span>
            <em>&mdash;Winston Churchill</em>
          </blockquote>
          <p>★ ★ ★ ★ ★</p>
        </div>
        <h3>My Core Tech</h3>
        <ul>
          <li>Full-stack development with MVC/MVVM architecture</li>
          <li>Front-End Frameworks and Libraries (React.js, Angular, Vue.js, jQuery)</li>
          <li>Back-End Frameworks (Node.js, PHP/Laravel/Symfony, Python/Django/Flask)</li>
          <li>API development (REST & GraphQL)</li>
          <li>Strong database management skills (MySQL, MongoDB, PostgreSQL)</li>
          <li>Continuous Integration (Git, Github, Bitbucket)</li>
          <li>Browser Extension Development(Chrome, Firefox, Edge, Safari(Xcode/Swift))</li>
          <li>eCommerce Solution</li>
          <li>AWS solution</li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import Hero from '../Hero';

export default {
  name: 'About',
  components: {
    Hero,
  },
  methods: {
    gaEvent(category, action, label) {
      this.$ga.event(category, action, label);
    },
  },
};
</script>

<style scoped>
.image-right {
  @media (min-width: 600px) {
    float: right;
    margin-left: 30px;
    margin-bottom: 20px;
  }

  figure {
    @media (max-width: 599px) {
      text-align: left;
    }
  }

  figcaption {
    @media (max-width: 599px) {
      margin-left: 0;
    }
  }
}

blockquote {
  background: #eaeaea;
  margin: 0;
  padding: 10px;
  font-size: 14px;
  border: 1px dashed #bdbdbd;
  border-radius: 3px;
}
</style>
